export default "__VITE_ASSET__VASwd5or__"